import React, { useState } from "react";
import Select from "react-select";
import {
  AddSubPolicyContainer,
  SubPolicy,
  LOB,
  SelectStyles,
  SubPolicyLabel,
} from "./AddSubPolicy.styled";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { ReactComponent as SubPolicyIcon } from "../../assets/svg/subpolicy-icon.svg";

const AddSubPolicy = ({
  id,
  deleteSubPolicy,
  lobsOnChange,
  subPolicyOnChange,
  lobsOption,
  index,
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(null);

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this sub-policy?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={() => {
          deleteSubPolicy(id);
          setOpenDeleteModal(null);
        }}
      />
    ) : null;
  };

  return (
    <div>
      <AddSubPolicyContainer>
        <SubPolicyLabel>
          <SubPolicyIcon />
          <label>Sub-policy{index}</label>
        </SubPolicyLabel>
        <SubPolicy>
          <label className="heading-label">
            Sub-policy<span className="mandatory"> *</span>
          </label>
          <input
            placeholder="Enter sub policy"
            onChange={(val) => {
              subPolicyOnChange(val.target.value, id);
            }}
          />
        </SubPolicy>
        <LOB>
          <label className="heading-label">
            LOB/s<span className="mandatory">*</span>
          </label>
          <Select
            styles={SelectStyles}
            isMulti={true}
            placeholder="Select an option"
            options={lobsOption}
            onChange={(val) => {
              lobsOnChange(val, id);
            }}
          />
        </LOB>
        <div className="deleteIcon">
          <label>Delete Policy</label>
          <IconButton
            onClick={() => {
              setOpenDeleteModal(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      </AddSubPolicyContainer>
      {showDeleteModal()}
    </div>
  );
};

export default AddSubPolicy;
